export const isAwsS3Image = (url: string) => url?.includes("s3.amazonaws.com") || false;

export default { isAwsS3Image };
